// extracted by mini-css-extract-plugin
export default {"dropdown":"DownloadDropdown-module__dropdown--VpTRY"};